/**
 * Swiper arrows component
 *
 * The same arrow class name should be in swiper definition with + '-prev' and '-next'
 *
 * Example:
 *  <swiper [navigation]="{
 *           nextEl: '.' + uid + '-next',
 *           prevEl: '.' + uid + '-prev'}"
 *
 * ## usage
 *
 * <slider-arrows [swiperPrefix]="uid"
 *                [topPosition]="'25%'"></swiper-arrows>
 */

import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SliderArrowComponent } from '../arrow/slider-arrow.component';

@Component({
    selector: 'slider-arrows',
    templateUrl: './slider-arrows.html',
    styleUrls: ['./slider-arrows.scss'],
    standalone: true,
    imports: [SliderArrowComponent, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SliderArrowsComponent {
    @Input()
    swiperPrefix: string;
}
